import { Loader } from "@coval/ui"

export function ClerkSigninRedirectStatus() {
  return (
    <div className="space-y-4 text-center md:text-left">
      <Loader size="lg" label="Signing you in…" />
      <div className="space-y-1.5">
        <h1 className="text-xl font-medium text-coval-text">Signing you in…</h1>
        <p className="text-sm leading-5 text-coval-text-muted">
          Taking you to your account.
        </p>
      </div>
    </div>
  )
}
